import React from 'react';
import { handleException } from '../../helper/helperError';


const ComStatCard = ({
    tooltip,
    label,
    value,
    trendDirection,
    trendChange,
    trendLabel,
    icon,
    color,
    url,
    size = 'large',
}) => {
    const isLarge = (size === 'large');

    const cardStyle = isLarge
        ? {
            borderLeft: `5px solid ${color || '#cccccc'}`,
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        }
        : {
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        };

    const handleMouseOver = (e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 .5rem 1rem rgba(0,0,0,.15)';
    };

    const handleMouseOut = (e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
    };

    const CardContent = () => (
        <div
            className="card shadow-sm h-100"
            style={cardStyle}
            title={tooltip}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        >
            <div className="card-body">
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="text-muted text-uppercase small fw-bold">{label}</div>
                        <div className={`fw-bold my-1 ${isLarge ? 'fs-4' : 'fs-5'}`}>{value}</div>
                        {isLarge && trendChange && (
                            <div className={`small ${trendDirection === 'up' ? 'text-success' : trendDirection === 'down' ? 'text-danger' : 'text-secondary'}`}>
                                <i className={`fa ${trendDirection === 'up' ? 'fa-arrow-up' : trendDirection === 'down' ? 'fa-arrow-down' : 'fa-minus'}`} />
                                {` ${trendChange} ${trendLabel || ""}`}
                            </div>
                        )}
                    </div>
                    {icon && (
                        <div className="ms-3">
                            <i
                                className={`fa ${icon} ${isLarge ? 'fa-4x' : 'fa-2x'}`}
                                style={{ color: color || '#6c757d', opacity: 0.5 }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    if (url) {
        return (
            <div className={isLarge ? "col-12 col-md-6 col-xl-4" : "col-12 col-sm-6 col-lg-3"}>
                <a href={url} className="text-decoration-none text-dark h-100 d-block">
                    <CardContent />
                </a>
            </div>
        );
    }

    return (
        <div className={isLarge ? "col-12 col-md-6 col-xl-4" : "col-12 col-sm-6 col-lg-3"}>
            <CardContent />
        </div>
    );
};

export default ComStatCard;